export default __webpack_public_path__ + "static/media/error.2660be57.svg";